import { extendTheme } from "@chakra-ui/react";

const theme = extendTheme({
  config: {
    initialColorMode: "dark",
    useSystemColorMode: false,
  },
  styles: {
    global: {
      // Apply a global background color to the body
      "body, html": {
        bg: "white", // Example color
      },
      // Make text non-selectable and elements non-draggable globally
      "*": {
        userSelect: "none",
        WebkitUserDrag: "none", // For Safari
        MozUserDrag: "none", // For Firefox
        msUserDrag: "none", // For IE
        userDrag: "none", // Standard
      },
      // Hide scrollbar globally
      "::-webkit-scrollbar": {
        display: "none",
      },
      "-ms-overflow-style": "none",  // IE and Edge
      "scrollbar-width": "none",  // Firefox
      "@media (max-width: 768px)": {
        ".profile-container": {
          height: "auto", // Adjust height for mobile
          overflowY: "auto", // Ensure scrolling is possible
        },
      },
    },
  },
  components: {
    Box: {
      baseStyle: {
        bg: "white", // Set default background color for Box
        draggable: "false", // Ensure Box is non-draggable
        overflow: "auto", // Allow scrolling within the Box
      },
    },
    Flex: {
      baseStyle: {
        bg: "white", // Ensure Flex also uses the same background color
        draggable: "false", // Ensure Flex is non-draggable
        overflow: "auto", // Allow scrolling within the Flex
      },
    },
    Button: {
      baseStyle: {
        bg: "white", // Example for Button
        draggable: "false", // Ensure Button is non-draggable
      },
    },
    Grid: {
      baseStyle: {
        gap: '1', // Default gap between grid items
        color: 'blackAlpha.700', // Default text color
        fontWeight: 'bold', // Default font weight
        overflowY: 'auto', // Default overflow behavior
      },
    },
    // Add other components as needed, ensuring they use the same bg color
  },
});

export default theme;
